import { useTranslation } from 'react-i18next';
import { AsyncSearchAdvertiserField, SingleAsyncSearchAdvertiserFieldProps } from '@anytag/shared-molecules';
import { MarketplaceFormKeys } from '../types';

export type AdvertiserFieldProps = Omit<
  SingleAsyncSearchAdvertiserFieldProps<MarketplaceFormKeys>,
  'name' | 'multiple'
>;

export const AdvertiserField = (props: AdvertiserFieldProps) => {
  const { t } = useTranslation();

  return (
    <AsyncSearchAdvertiserField
      help={t('Tooltip.Advertiser')}
      title={t('Selector.Advertiser')}
      name={MarketplaceFormKeys.advertiserId}
      {...props}
    />
  );
};
